
/*============================================================================
  Variables
==============================================================================*/

var reveal_object           = []; //this stores all the elements that should be revealed only when in view
var window_scroll_callbacks = $.Callbacks(); // stores all of the callbacks that should be fired during window scroll event
var window_resize_callbacks = $.Callbacks(); // stores all of the callbacks that should be fired during the window resize event
var flip_card_set           = []; //stores all of the flip card sets
var reveal_obj_id_count     = 0; //used as a counter to create unique ids
var transformPrefix         = ["transform", "-webkit-transform", "-ms-transform", "-moz-transform", "-o-transform"];
var transitionEndEvents     = "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend";



/*============================================================================
  jQuery Extensions
==============================================================================*/

jQuery.fn.extend({
  addDelayCode: function(time) {
    var $obj = $(this);

    $obj.css('-webkit-transition-delay', time + 's, ' + time + 's '   );
    $obj.css('-moz-transition-delay', time + 's, ' + time + 's '   );
    $obj.css('-o-transition-delay', time + 's, ' + time + 's '  );
    $obj.css('transition-delay', time + 's, ' + time + 's ' );
     
  },
	primeReveal: function(additional_delay) {
    /**
    *
    * This function sets the delay of reveal on each element in the given set
    * This creates the gradual reveal of 'one after another' effect
    *
    **/
    
    additional_delay  = typeof additional_delay !== 'undefined' ? additional_delay : 0;
    cur_offset_top    = 0; //the current top offset value to compare against
    item_count        = 0; //the count of elements in the current row
    delay             = 0.3; //the arbitrary delay value to be used in the delay between revealing in the same row
    $selector         = $(this);

    $selector.each(function(index){
      $cur_obj = $(this);
      if ($cur_obj.css('transition-delay') != '' && !$cur_obj.hasClass('revealed') ) {
        //if the element is already revealed or has a transition-delay property then we don't need to set it again

        if ( parseInt($cur_obj.offset().top) != cur_offset_top) {
          /**
          *
          * We determine what delay value should be used based on whether is shares the same top offset value with other
          * elements in the set. If the top offset of the previous element is different from the current one this would indicate
          * a new row. We can reset the item_count and set this element's top offset and the cur_offset_top value. 
          *
          **/
          
          cur_offset_top = parseInt($cur_obj.offset().top);
          item_count = 0;
        }
       
        $cur_obj.addDelayCode((delay * item_count) + additional_delay );
        item_count++;
        
        var reveal_obj_id = 'reveal-id-' + reveal_obj_id_count++;
        //we add this element to the reveal_object array to later be revealed
        reveal_object[reveal_obj_id] = $cur_obj;
      }
        
    });

	},
  enableFlipCardBackClick: function() {
    $(this).click(function() {
      var product_page_link = $(this).find('a').attr('href');
      window.location.assign(product_page_link);
    });
  },
  wrapInSpan: function() {
    $(this).each(function( index ) {
      $curButton = $(this);
      if ( !$curButton.children('span').length ) {
        var innerHtml = $curButton.html();
        innerHtml = '<span>' + innerHtml + '</span>';
        $curButton.html(innerHtml);
      }
    });
  }
});


/*============================================================================
  Flip Card Set Object
==============================================================================*/
 
var FlipCardSet = function($group) {
	//we isolate the flip cards into groups so that the flip toggling is specific for the group, for touch devices
	
  this.$group = $group;

	this.setFlipCardSize = function() {
		//we need to set the some sizes on the flip cards before the flip functionality can be enabled 

		this.$group.each(function() {
    	/**
      *
      * Setting the flip card dimensions to square and sizing the images appropriately.
      * Images can be wider or taller and this needs to be accounted for.
      *
      **/
      
    	$( this).find('img').each(function( index ) {
			  $cur_img = $(this);
			  if ( $cur_img.height() > $cur_img.width() ) {
			  	$cur_img.addClass('tall');
			  } else {
			  	$cur_img.addClass('wide');
			  }
			});

    	$cur_flip_card = $(this);
    	$cur_card = $(this).children('.card');
    	$cur_flip_card.removeClass('size-set');
    	$cur_card.height('');
    	$cur_card.width('');

    	$cur_flip_card.height( $cur_flip_card.width() );
    	$cur_card.height( $cur_flip_card.width() );
    	$cur_card.width( $cur_flip_card.width() );

    	$cur_flip_card.addClass('size-set');
	      	
	  });
	};


  this.showFlipCardOverlay = function(e) {
    if (  $.inArray(e.originalEvent.propertyName, transformPrefix) >= 0 ) {
      //the overaly on the flip card is shown again after the transform transition is complete
      
      $(e.target).parent().removeClass('overlay-hidden');
      $(e.target).off(transitionEndEvents);
    }
  };


  this.hideFlipCardOverlay = function(e) {
    if (  $.inArray(e.originalEvent.propertyName, transformPrefix) >= 0 ) {    
      //the overlay on the flip card is hidden after the transform transition is complete
      
      $(e.target).parent().addClass('overlay-hidden');
      $(e.target).off(transitionEndEvents);
    }
  };


  this.initFlipCardEventBinding = function() {  
    	var $flip_card = this.$group;

      //used for testing
    	//$('html').addClass('supports-no-csstransforms3d');
    	//$('html').removeClass('supports-csstransforms3d');
      //Modernizr.csstransforms3d = 0; 

  		if (Modernizr.csstransforms3d) {
	      //The flip cards require css 3D transforms. We need to check for this and display an alternative animation if the browser does not support this

        if (Modernizr.touch ) {
          //events are handled differently depending on touch event vs click

          $flip_card.find( ".overlay" ).on( "vclick",  function(e) {
          	//because of how touch events work on some devices, we need to attach the flip event to a transparent overlay element

          	var $event_source_card = $(this).parent().children('.card');
          	var $event_source_flip_card = $(this).parent();
            var $flipped_cards = $flip_card.parent().children('.flipped');
            
            $flipped_cards.children('.card').on(transitionEndEvents, $.proxy(this.showFlipCardOverlay, this) );
            $flipped_cards.removeClass('flipped');

						$event_source_card.on(transitionEndEvents, $.proxy(this.hideFlipCardOverlay, this) );
            $event_source_flip_card.addClass('flipped');
              
          });

        } else {
	            
        	$flip_card.on('mouseenter', function(e) {
            $(this).addClass('flipped');
        	});

        	$flip_card.on('mouseleave', function(e) {
						$(this).removeClass('flipped');
        	});

        	$flip_card.find('a').on('focus', function(e) {

          	$event_source_flip_card = $(this).closest('.flip-card');
						$event_source_flip_card.addClass('flipped');

        	});

        	$flip_card.find('a').on('blur', function(e) {

            $event_source_flip_card = $(this).closest('.flip-card');
						$event_source_flip_card.removeClass('flipped');

        	});

        }
	        
	    } else {
	        
        if (Modernizr.touch ) {
            
          $flip_card.find( ".overlay" ).on( "click",  function() { 
          	var $event_source_text_container = $(this).parent().children('.text-container');
          	var $event_source_flip_card = $(this).parent();

            $flip_card.parent().children('.slide-up-panel-shown').removeClass('slide-up-panel-shown overlay-hidden');

            $event_source_flip_card.addClass('slide-up-panel-shown overlay-hidden');

          });
            
        } else {
            
          $flip_card.hover(
            function() {
              $(this).addClass('slide-up-panel-shown');
            }, function() {
              $(this).removeClass('slide-up-panel-shown');
            }
          );
        }
	    }
  	};
};



/*============================================================================
  Functions
==============================================================================*/

var checkRevealPos = function() {
  //on a window scroll event this function is executed.
  var is_touch_device = Modernizr.touch;
  
  for (var index in reveal_object) {
    /**
    *
    * all of the items in the reveal_object associate array are iterated through to see if they should be set to 'revealed'
    * we only want elements to be revealed when in view
    *
    **/
    
    $cur_obj = reveal_object[index];
    
    /**
    *
    * On touch devices the scroll event fires too late and looks bad. 
    * On touch devices we simply set the element to 'revealed' even if it is not in view
    *
    **/
    if (Modernizr.touch || !Modernizr.csstransitions) {
      $cur_obj.addClass('revealed');
      delete reveal_object[index];
    } else {
      if ( $(document).scrollTop() < ( $cur_obj.offset().top + ($cur_obj.outerHeight() ) ) &&
        ( $(document).scrollTop() + $(window).height() + ($cur_obj.outerHeight() / 2)  ) > ( $cur_obj.offset().top + ($cur_obj.outerHeight() ) )
        ) {
        // We check to see if the element is in screen view 
          
        $cur_obj.addClass('revealed');

        /**
        *
        * we remove this item from the reveal_object array since we no longer to check whether it should be revealed
        * removing the element also increases webpage performance
        *
        **/
        delete reveal_object[index];

        // Object.keys is an ES5 method, thus not supported in IE8 so we need to check for this
        if (typeof Object.keys != "undefined" && !Object.keys(reveal_object).length) {
          // if we have no more objects to be revealed, then we can deregister this callback to improve performance

          window_scroll_callbacks.remove(checkRevealPos);
        }
      }        
    }    
  }
}


var resizeFlipCardSets = function() {
	for	(index = 0; index < flip_card_set.length; index++) {
    flip_card_set[index].setFlipCardSize();
	}
}


var primeRevealResizeCallback = function() {
	$('.flip-card').primeReveal();
	$('.home-intro h1').primeReveal();
	$('.home-intro hr').primeReveal();
	$('.home-intro h2').primeReveal(0.2);

	$('.product-single__thumbnails a').primeReveal();
}


var flipCardGroupInit = function() {
  $( ".flip-card-group" ).each(function( index ) {
    var flip_card = new FlipCardSet( $(this).find('.flip-card') );
    
    flip_card.setFlipCardSize();
    flip_card.initFlipCardEventBinding();
    flip_card_set[flip_card_set.length] = flip_card;
    if ( !window_resize_callbacks.has('resizeFlipCardSets')) {
      window_resize_callbacks.add(resizeFlipCardSets);
    }
  });

  $('.flip-card').primeReveal();

  window_scroll_callbacks.add(checkRevealPos);
  window_resize_callbacks.add(primeRevealResizeCallback);

  $(window).trigger('scroll');
}


var productPhotoInit = function() {
  $('.product-single__thumbnails a').primeReveal();
  $('.product-single__photos').primeReveal();
  $(window).trigger('scroll');
}


var detectIE = function() {
  /**
  *
  * Since no version of Internet Explorer supports transform-style: preserve-3d style we need to check for this
  * since it impacts how the flip cards work. After unsuccessfully trying to extend Modernizr with:
  *
  * define(['Modernizr', 'testAllProps'], function (Modernizr, testAllProps) {
  *   Modernizr.addTest('preserve3d', testAllProps('transformStyle', 'preserve-3d'));
  * });
  *
  * a temporary solution is to check for IE and add a class to the body element to activate the appropriate CSS
  **/

  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    $('body').addClass('is-ie');
  }
 
}  

var detectChromeMac = function() {
  //the home page feature text anchor borders are too tight at the bottom, but only in Chrome on MacOS (not iOS)
  //as a hack we check the user agent and add a style to the body element to trigger special CSS in this case
  
  var nAgt = navigator.userAgent;
  var isMac = 0;
  var isChrome = 0;
  
  //console.log(nAgt);

  if ( navigator.appVersion.indexOf("Mac") != -1 ) {
    //console.log('is mac');
    isMac = 1;
  }

  if ((nAgt.indexOf("Chrome")) != -1) {
    //console.log('is chrome');
    isChrome = 1;
  }

  if (isMac && isChrome) {
    $('body').addClass('is-mac-chrome');
  }

}
  
var setTabControlActivated = function(e) {
  if (e.which == 9) {
    //if tab pressed
    
    //e.preventDefault();
    $('body').addClass('tab-control-detected');
  }
} 
 

/*============================================================================
  Document Ready
==============================================================================*/
	
$(document).ready(function() {
	detectChromeMac();
  detectIE();

  FastClick.attach(document.body);
  
	imagesLoaded( ".flip-card-group", flipCardGroupInit);
	imagesLoaded( '.product-single__thumbnails a, .product-single__photos', productPhotoInit);

  $('a#skip-link').click(function(e) {
    e.preventDefault();
    $('#skip-anchor').focus();
  });

  //allows the entire back of flip cards to be clickable
  $('.flip-card .back').enableFlipCardBackClick();

	$('.home-intro h1').primeReveal();
	$('.home-intro hr').primeReveal();
	$('.home-intro h2').primeReveal(0.2);
	
  //buttons need to have a span child element due to the technique used to simulate transitions on background gradients
	$( ".multiface-button, .home-intro a" ).wrapInSpan();

  $(document).on('keydown', setTabControlActivated);

  if (!Modernizr.touch) {
    $("html").niceScroll({
      scrollspeed:60,
      mousescrollstep:40,
      cursorwidth: 15,
      cursorborder: 0,
      cursorcolor: 'rgba(0,0,0,0.7)',
      cursorborderradius: '2px',
      autohidemode: false,
      horizrailenabled: false,
      zindex:9999
    });
  }
});



/*============================================================================
  Window Callbacks
==============================================================================*/

$( window ).scroll(function() {
  window_scroll_callbacks.fire();
});

$( window ).resize(function() {
  window_resize_callbacks.fire();
  $(window).trigger('scroll');
});